
const FilterSelect = () => {

    return (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_858_2644)">
                <path d="M37 3H3V37H37V3Z" fill="var(--check-box-colour)" stroke="var(--check-box-colour)" strokeWidth="6.24305"
                      strokeMiterlimit="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                <path fillRule="evenodd" clipRule="evenodd"
                      d="M8.87417 23.5365L13.8723 28.5346C14.9072 29.5695 16.5862 29.5692 17.6206 28.5348C18.655 27.5003 18.6554 25.8214 17.6204 24.7864L12.6223 19.7883C11.5874 18.7534 9.9084 18.7537 8.87398 19.7881C7.83957 20.8225 7.83921 22.5015 8.87417 23.5365Z"
                      fill="white"/>
                <path fillRule="evenodd" clipRule="evenodd"
                      d="M17.6201 28.5402L30.5353 15.625C31.5695 14.5908 31.5717 12.9093 30.5373 11.8749C29.5028 10.8405 27.8214 10.8427 26.7872 11.8769L13.872 24.7921C12.8378 25.8263 12.8357 27.5076 13.8702 28.542C14.9046 29.5765 16.5859 29.5744 17.6201 28.5402Z"
                      fill="white"/>
            </g>
            <defs>
                <clipPath id="clip0_858_2644">
                    <rect width="40" height="40" fill="white"/>
                </clipPath>
            </defs>
        </svg>

    )
}

export default FilterSelect;
